import { isDefinedArray } from "et3-type-guards";
import getApproveRejectStore from ".";

export const hasMorePendingImages = ({ index }: { index: number }): boolean => {
  const userApprovalData = getApproveRejectStore().approvalData.get()[index];
  const userAlbum = userApprovalData.albumPicture;
  const hasImages = isDefinedArray(userAlbum);
  if (!hasImages) {
    return false;
  }
  const hasPendingImages = userAlbum.some((image) => {
    return image.status === "P" && image.isActive === 1;
  });
  return hasPendingImages;
};
